/** Reference copy for the Sales Velocity heatmap metrics guide modal. */
export const SALES_VELOCITY_METRICS_GUIDE_ROWS = [
  {
    metric: 'Sell-through',
    measures:
      'Of all events where this seat could sell, what % of those events did it actually sell?',
    useWhen: (
      <>
        See <strong>which sections sell out first</strong> over time — best for
        layout, marketing photos, and &quot;hot&quot; vs &quot;cold&quot; zones.
      </>
    ),
  },
  {
    metric: 'Demand heat',
    measures: 'Same idea as sell-through, shown as intensity (0–100%).',
    useWhen: (
      <>
        Spot <strong>hottest demand by seat</strong> on the map; good for
        dynamic pricing and holding premium inventory.
      </>
    ),
  },
  {
    metric: 'Days to sell',
    measures: (
      <>
        On average, how many <strong>days before show time</strong> tickets here
        sold.
      </>
    ),
    useWhen: (
      <>
        Learn <strong>how early fans buy</strong> each area. Short days = sells
        fast; long days = sells late. <em>Cooler colors = slower.</em> Use for
        release timing and last-minute promos.
      </>
    ),
  },
  {
    metric: 'Gross revenue',
    measures: (
      <>
        Total <strong>dollar sales</strong> from that seat across history.
      </>
    ),
    useWhen: (
      <>
        Find <strong>money makers</strong> — where to protect price, add VIP
        packages, or invest in experience.
      </>
    ),
  },
  {
    metric: 'Avg ticket price',
    measures: 'Average price paid for tickets at that seat.',
    useWhen: (
      <>
        Compare <strong>pricing tiers</strong> across the building — are
        expensive seats earning their price?
      </>
    ),
  },
  {
    metric: 'Scan rate',
    measures: (
      <>
        Of sold tickets here, what % were <strong>scanned at the door</strong>{' '}
        (actually showed up)?
      </>
    ),
    useWhen: (
      <>
        See <strong>no-show vs show-up</strong> patterns — useful for oversell
        policy, will-call, and security staffing by section.
      </>
    ),
  },
  {
    metric: 'Comp & promo load',
    measures: (
      <>
        What % of tickets here were <strong>free/comp</strong> vs paid.
      </>
    ),
    useWhen: (
      <>
        See where <strong>comps and promos</strong> pile up.{' '}
        <em>Warmer = more comps.</em> Use to audit giveaways and fix areas that
        only move with free tickets.
      </>
    ),
  },
]
